import Numeral from "react-numeral";
import { Dashboards } from "../../../components/backgrounds/Dashboards";
import { Tertiary } from "../../../components/buttons/Tertiary";
import { Fragment, useState, useEffect } from "react";
import { Link, useLocation, useNavigate, redirect } from "react-router-dom";
import { v4 as uuid } from "uuid";
import { validateSessionAndJwtToken } from "../../../utils/validateTokenSession";
import { SkeletonDahsboard } from "../../../components/skeleton/skeletonDash";
import { AcciValPage } from "./AcciValPage";
import { ToggleApiPaymentsService } from "../../../services/toggle_api_payments/toggle_api_payments.service";
import { AwaitPaymentModal } from "../../../components/modals/ModalCobreAwaitPayment";
import { FeaturesMethodPage } from "./features";
import { CobreService } from "../../../services/cobre/cobre.service";
import { environment, variablesGlobales } from "../../../configs/variables";
import moment from "moment";
import { HttpRequest } from "../../../services/httpRequest";
import { returnToSignin } from "../../../utils/returnToSign";
import { DashboardMyCredit } from "../../../components/backgrounds/DashboardMyCredit";
import { useCredit } from "../../../context/creditContext";
import { PrimaryMobile } from "../../../components/buttons/mobile/Primary";
import { IndexedDBService } from "../../../services/indexedDbService";
import { SuccessAlert } from "../../../components/alerts/successAlert";
import { ErrorAlert } from "../../../components/alerts/errorAlert";
import { SkeletonMethodsPage } from "./components/skeleton_methods_page";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const apiPaymentsDefault = "ACCIVAL";
const indexedDbService = new IndexedDBService();

export function MethodsPage() {
  const { disclosures, creditInfo, due } = useCredit();
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state?.data;
  const [isLoading, setIsLoading] = useState(true);
  const [features, setFeatures] = useState([]);
  const [apiPayments, setApiPayments] = useState(apiPaymentsDefault);
  const [showModalAwaitPayment, setShowModalAwaitPayment] = useState(false);
  const [returnAccivalPage, setReturnAccivalPage] = useState(false);
  const [modalMessagetitle, setModalMessagetitle] = useState(
    "Estamos redirigiendo hacia la pasarela de pago ..."
  );
  const [globalAmount, setGlobalAmount] = useState("");
  const [concatExtendPayData, setConcatExtendPayData] = useState("");
  const [viewalert, setViewalert] = useState(false);
  const [messsageAlert, setMessageAlert] = useState("");
  const [isOpenSuccess, setIsOpenSuccess] = useState(false);
  const [isOpenError, setIsOpenError] = useState(false);

  const handleOpenAlert = (type, message, isOpen) => {
    if (type === "success") {
      setMessageAlert(message);
      setIsOpenSuccess(isOpen);
      setViewalert(isOpen);
    }
    if (type === "error") {
      setMessageAlert(message);
      setIsOpenError(isOpen);
      setViewalert(isOpen);
    }
  };

  const handleClearStateAlert = () => {
    setViewalert(false);
    setMessageAlert("");
    setIsOpenSuccess(false);
    setIsOpenError(false);
  };

  let randomDate = "01/01/1992";

  const loadTogglePayment = async () => {
    try {
      const data = await ToggleApiPaymentsService.getData();
      return data.message.data;
    } catch (error) {
      console.log(error);
    }
  };

  const loadInfoUser = async () => {
    try {
      const data = await HttpRequest.getInfoUser(localStorage.getItem("doc"));
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  };

  const toggleReturnAccivalPage = () => {
    setReturnAccivalPage(!returnAccivalPage);
  };

  const toggleShowModal = () => {
    setShowModalAwaitPayment(!showModalAwaitPayment);
  };

  const handleRedirectToCashView = () => {
    let urlRedirect =
      data?.extendPlazo === true
        ? `/pago-efectivo-extend`
        : `/opciones-efectivo`;
    return navigate(urlRedirect);
  };

  const handleClickBtnCobre = async () => {
    try {
      toggleShowModal();
      handleClearStateAlert();

      const loadInfo = async () => {
        let info = await loadInfoUser();
        return info;
      };

      let info;
      let fullName = `${data?.name} ${data?.lastname}`;

      try {
        info = await loadInfo();
        fullName = `${info?.firstname} ${info?.firstlastname}`;
      } catch (error) {
        console.log(
          "Ocurrió un error al solicitar la info basica del usuario."
        );
      }

      let payloadPaymentLinkV3 = {
        alias: fullName,
        amount: globalAmount,
        external_id: localStorage.getItem("credit_id"),
        source_id: localStorage.getItem("doc"),
        destination_id: localStorage.getItem("credit_id"),
        checkout_rails: [
          "pse"
        ],
        checkout_header: "Galilea fintech",
        checkout_item: `Pago de crédito #${localStorage.getItem("credit_id")}`,
        description_to_payee: `Pago de crédito #${localStorage.getItem("credit_id")}`,
        valid_until: moment().add(1, 'days').format("YYYY-MM-DD HH:mm:ss"),
        money_movement_intent_limit: 5,
        redirect_url: variablesGlobales.urlRedirectCobre,
      }

      let payloadPaymentLink = {
        cellPhone: `+57${localStorage.getItem("phone")}`,
        email: localStorage.getItem("email"),
        amount: globalAmount,
        document: localStorage.getItem("doc"),
        documentType: "CC",
        expirationDate: moment().format("YYYY-MM-DD"),
        fullName: fullName,
        description: `Pago de crédito #${localStorage.getItem("credit_id")}`,
        references: [localStorage.getItem("credit_id")],
        notificationMethods: ["ONLINE"],
        redirectUrl: variablesGlobales.urlRedirectCobre,
        enabledPaymentMethods: ["PSE", "BANCOLOMBIA", "NEQUI"],
        currency: "COP",
      };

      if (data?.extendPlazo && !concatExtendPayData) {
        handleOpenAlert('error', 'No se ha podido generar el link de pago, por favor intente nuevamente.', true);
        setShowModalAwaitPayment(false);
        return setTimeout(() => {
          navigate('/micredito');
        }, 4000);
      }

      let { error, message } = await CobreService.generatePaymentLink({
        payload: payloadPaymentLink,
        additionalData: {
          concatExtendPayData: btoa(concatExtendPayData),
        },
        creditId: localStorage.getItem("credit_id"),
      });
      if (error === true) {
        setModalMessagetitle("");
        return toggleReturnAccivalPage();
      }
      let linkUrlCobre = message?.linkUrl;
      if (linkUrlCobre) {
        setShowModalAwaitPayment(false);
        return window.location.href = linkUrlCobre;
      } else {
        setModalMessagetitle("");
        return toggleReturnAccivalPage();
      }
    } catch (error) {
      console.log(error);
      setModalMessagetitle("");
      return toggleReturnAccivalPage();
    }
  };

  useEffect(() => {
    const validSessionAndTokenJwt = async () => {
      try {
        let isValidToken = await validateSessionAndJwtToken();
        return isValidToken;
      } catch (error) {
        return false;
      }
    };

    const loadTogglePayments = async () => {
      try {
        return loadTogglePayment();
      } catch (error) {
        console.log(error);
        return [];
      }
    };

    validSessionAndTokenJwt()
      .then(async (isValidToken) => {
        if (isValidToken) {
          let toggleApiPayments = [];
          let _amount = data?.extendPlazo === true ? String(data?.totalSinCapital) : String(data?.amount);
          try {
            let item = await indexedDbService.findItem('id', localStorage.getItem('credit_id'));
            if (!item) {
              await indexedDbService.addItem({ amount: _amount, id: localStorage.getItem('credit_id'), hasExtend: data?.extendPlazo });
            }
            if (!_amount || _amount === undefined || _amount === 'undefined') {
              _amount = item?.amount;
              environment !== 'PROD' && console.log('amount actualizado', _amount);
            }
          } catch (error) {
            console.error(error);
            return navigate('/pagar');
          }

          setGlobalAmount(_amount);
          if (data && data?.extendPlazo) {
            if (data.extendPlazo === true) {
              setConcatExtendPayData(
                `${data?.extendPlazo};${data?.dateExtend
                };${localStorage.getItem("doc")}`
              );
            } else {
              setConcatExtendPayData(
                `${data?.extendPlazo};${randomDate};${localStorage.getItem(
                  "doc"
                )}`
              );
            }
          }
          setFeatures(FeaturesMethodPage({ extendPlazo: data?.extendPlazo }));
          toggleApiPayments = await loadTogglePayments();
          let _apiPayments = toggleApiPayments[0];
          if ("apiPayments" in _apiPayments) {
            setApiPayments(_apiPayments.apiPayments);
          }
          setIsLoading(false);
          return;
        } else {
          returnToSignin(navigate);
        }
      })
      .catch((e) => {
        console.log(e);
        returnToSignin(navigate);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return (
      <SkeletonMethodsPage />
    );
  }

  return (
    <Fragment>
      {viewalert && (
        <>
          <SuccessAlert
            isOpen={isOpenSuccess}
            message={messsageAlert}
          ></SuccessAlert>
          <ErrorAlert isOpen={isOpenError} message={messsageAlert}></ErrorAlert>
        </>
      )}
      <DashboardMyCredit
        current3={true}
        name={data?.name}
        current={"2"}
        balance={data?.amount}
        title={"Medio de pago"}
        disclosures={disclosures}
        creditInfo={creditInfo}
        due={due}
        main={
          <div className="pb-32 md:pb-0 px-0 md:px-8 lg:px-0">
            <>
              {apiPayments && apiPayments === "COBRE" ? (
                <div className="relative py-10 grid grid-cols-8 gap-4">
                  {features.map((feature, index) => (
                    <div
                      key={index}
                      className={
                        "col-span-8 xl:col-span-4 grid content-between h-full rounded-3xl transition shadow-lg py-4 bg-white"
                      }
                    >
                      <div
                        key={index}
                        className={
                          feature.classTitle || "flex justify-between pb-6"
                        }
                      >
                        <div className="flex text-lg font-bold mx-auto pt-2">
                          <img
                            className="w-8 h-auto mr-2"
                            src={feature.img}
                            alt="medios-de-pago-galilea"
                          />
                          <h3 className="">{feature.title}</h3>
                        </div>
                      </div>

                      <div className="px-4 pt-6">
                        {feature.details.map((detail, i) => (
                          <div key={detail.id}>
                            <div className="flex pb-4">
                              <detail.icon
                                className="w-6 h-auto mr-4"
                                aria-hidden="true"
                              />
                              <div className="">
                                {detail.description}{" "}
                                <Numeral
                                  format={"$0,0"}
                                  value={detail.number}
                                />{" "}
                              </div>
                            </div>
                            <div
                              key={detail.id}
                              className="text-xl font-bold mx-auto uppercase text-center"
                            >
                              <span
                                className={classNames(
                                  detail.alert === "Vigente"
                                    ? "text-white bg-purple px-4 py-2 rounded-md"
                                    : detail.alert === "Al día"
                                      ? "text-white bg-tdark px-4 py-2 rounded-md"
                                      : detail.alert === "En mora"
                                        ? "text-white bg-red px-4 py-2 rounded-md"
                                        : "text-tdark font-medium"
                                )}
                              >
                                {detail.alert}
                              </span>
                            </div>
                          </div>
                        ))}
                        {feature.wompiPay ? (
                          <Link onClick={handleClickBtnCobre}>
                            <div className="flex pr-4 justify-end">
                              <PrimaryMobile text={"Pagar ahora"} />
                            </div>
                          </Link>
                        ) : (
                          <Link
                            to={feature.href}
                            state={{
                              data: {
                                amount: globalAmount,
                                name: data?.name,
                                extendPlazo: data?.extendPlazo,
                              },
                            }}
                          >
                            <div className="flex pr-4 justify-end">
                              <PrimaryMobile text={"Pagar ahora"} />
                            </div>
                          </Link>
                        )}
                      </div>
                    </div>
                  ))}

                  {showModalAwaitPayment && (
                    <AwaitPaymentModal
                      isOpen={showModalAwaitPayment}
                      title={"Espere un momento."}
                      messageTitle={modalMessagetitle}
                      ContentAction={
                        <AcciValPage
                          payload={{
                            orderNumber: uuid(),
                            amount: globalAmount,
                            email: localStorage.getItem("email"),
                            phone: localStorage.getItem("phone"),
                            firstname: data?.name,
                            lastname: data?.lastname,
                            doctype: "4",
                            documento: localStorage.getItem("doc"),
                            orderDescription: `Pago de crédito #${localStorage.getItem(
                              "credit_id"
                            )}`,
                            additionalData: btoa(concatExtendPayData),
                          }}
                        />
                      }
                      showContentAction={returnAccivalPage}
                    ></AwaitPaymentModal>
                  )}
                </div>
              ) : (
                <div className="relative py-10 grid grid-cols-8 gap-4">
                  {features.map((feature, index) => (
                    <a
                      target={feature.wompiPay ? "_blank" : "_self"}
                      key={index}
                      href={feature.href}
                      className={
                        "col-span-8 border-2 border-purple xl:col-span-4 grid content-between h-full rounded-3xl transition shadow-lg py-4 bg-white"
                      }
                    >
                      <div
                        key={index}
                        className={
                          feature.classTitle || "flex justify-between pb-6"
                        }
                      >
                        <div className="flex text-lg font-bold mx-auto pt-2">
                          <img
                            className="w-8 h-auto mr-2"
                            src={feature.img}
                            alt="medios-de-pago-galilea"
                          />
                          <h3 className="">{feature.title}</h3>
                        </div>
                      </div>
                      <div className="px-4 pt-6">
                        {feature.details.map((detail) => (
                          <div key={detail.id}>
                            <div className="flex pb-4">
                              <detail.icon
                                className="w-6 h-auto mr-4"
                                aria-hidden="true"
                              />
                              <div className="">
                                {detail.description}{" "}
                                <Numeral
                                  format={"$0,0"}
                                  value={detail.number}
                                />{" "}
                              </div>
                            </div>
                            <div
                              key={detail.id}
                              className="text-xl font-bold mx-auto uppercase text-center"
                            >
                              <span
                                className={classNames(
                                  detail.alert === "Vigente"
                                    ? "text-white bg-purple px-4 py-2 rounded-md"
                                    : detail.alert === "Al día"
                                      ? "text-white bg-tdark px-4 py-2 rounded-md"
                                      : detail.alert === "En mora"
                                        ? "text-white bg-red px-4 py-2 rounded-md"
                                        : "text-tdark font-medium"
                                )}
                              >
                                {detail.alert}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className="flex pr-4 justify-end">
                        {feature.wompiPay ? (
                          <AcciValPage
                            payload={{
                              orderNumber: uuid(),
                              amount:
                                data?.extendPlazo === true
                                  ? data?.totalSinCapital
                                  : data?.amount,
                              email: localStorage.getItem("email"),
                              phone: localStorage.getItem("phone"),
                              firstname: data?.name,
                              lastname: data?.lastname,
                              doctype: "4",
                              documento: localStorage.getItem("doc"),
                              orderDescription: `Pago de crédito #${localStorage.getItem(
                                "credit_id"
                              )}`,
                              additionalData: btoa(concatExtendPayData),
                            }}
                          />
                        ) : (
                          <Tertiary text={"Pagar ahora"} />
                        )}
                      </div>
                    </a>
                  ))}
                </div>
              )}
            </>
          </div>
        }
      />
    </Fragment>
  );
}
